<template>
<div class="d-inline" :style="'width:' + size + 'px;height:' + size + 'px;'" :id="id">
    <d-skeleton :width="size" :height="size" v-if="isLoading"></d-skeleton>
    <d-svg v-else-if="ismodal" :src="helpicon" :width="size" :height="size" class="dod-help-icon" @click="ShowModal" />
    <d-svg v-else-if="istooltip" :id="tooltip_id" :src="helpicon" :width="size" :height="size" class="dod-help-icon" />
    <d-svg v-else-if="ispopover" :id="popover_id" :src="helpicon" :width="size" :height="size" class="dod-help-icon"  @click="ShowPopover" />       
    <d-modal v-if="ismodal" :id="modal_id" :title="thetitle" hideok center ref="HelpModalRef" :variant="thevariant" :closebtnVariant="thevariant">
        <div v-html="thetext"></div>      
    </d-modal>
</div>
</template>

  
<script setup>
import { ref, computed, onMounted, defineProps, onUpdated} from 'vue';
import { Popover, Tooltip } from 'bootstrap'; // Import Bootstrap's JavaScript

// globals
import { useTranslationsStore} from '@/dod/store/dtranslations';
const translationsStore = useTranslationsStore(); // Use the globally registered store

import icons from "@/dod/enums/dicons";

const props = defineProps({
    size: { type: String, default: '20px' },
    title: String,
    text: String,
    displayType: {type: String, default: 'modal' },
    replaceValues: Object,
    loading: Boolean,
    translate: {type: Boolean, default: true},
    variant: String,
    trigger: String,
    placement: String
});

const idval = ref(0);
const HelpModalRef = ref(null);
const HelpPopoverRef = ref(null);
const HelpTooltipRef = ref(null);

const id = computed(() => `dod-help-${idval.value}`);
const modal_id = computed(() => `dod-help-modal-${idval.value}`);
const tooltip_id = computed(() => `dod-help-tooltip-${idval.value}`);
const popover_id = computed(() => `dod-help-popover-${idval.value}`);
const helpicon = computed(() => icons.common_icons.help);
const ispopover = computed(() => props.displayType === 'popover');
const istooltip = computed(() => props.displayType === 'tooltip');
const ismodal = computed(() => props.displayType === 'modal');

// const tootltipitem = computed(() => {
//     if (istooltip.value) {
//         return {
//             title: `<div class='bold'>${thetitle.value}</div><p>${thetext.value}</p>`,
//             placement: theplacement.value,
//             variant: thevariant.value,
//             trigger: thetrigger.value,
//             html: true
//         };
//     }
//     return {};
// });
const isLoading = computed(() => props.loading);
const thevariant = computed(() => props.variant || (ispopover.value ? 'info' : istooltip.value ? 'primary' : 'light'));
const thetrigger = computed(() => props.trigger || (ismodal.value ? 'click' : 'hover'));
const theplacement = computed(() => props.placement || 'top');

const thetext = computed(() => props.translate ? translatedText.value : props.text)
const translatedText = computed(() => translationsStore.translate(props.text, props.replaceValues))
const thetitle = computed(() => props.translate ? translatedTitle.value : props.title)
const translatedTitle = computed(() => translationsStore.translate(props.title, props.replaceValues))

function ShowModal(){
    HelpModalRef.value.Open();
}

function ShowPopover(){
    HelpPopoverRef.value.show();
}

onMounted(() => {
    idval.value = Math.random() * 3000000;   
});

onUpdated(() => {
    if(ispopover.value)
    {
        const the_popover_element = document.getElementById(popover_id.value)
        HelpPopoverRef.value = new Popover(the_popover_element, 
        {
            trigger: thetrigger.value,
            placement: theplacement.value,
            title: thetitle.value,
            customClass: thevariant.value,
            content: thetext.value,
        })
        
    }
    else  if(istooltip.value)
    {
        const the_tooltip_element = document.getElementById(tooltip_id.value)
        HelpTooltipRef.value = new Tooltip(the_tooltip_element, 
        {
            trigger: thetrigger.value,
            placement: theplacement.value,
            html: true,
            customClass: thevariant.value,
            title: `<div class='dod-help-tooltip-title'>${thetitle.value}</div><p>${thetext.value}</p>`
        })
        
    }
});

</script>